import i18n from './locales/index.js';
import Vue from 'vue'
import App from './App.vue'
import "@/api/index.js"; // 接口文件
import router from "./router/index.js";
import store from "./store/index.js";
import md5 from 'js-md5'
Vue.config.productionTip = false
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '../public/static/css/element-variables.scss';
import locale from 'element-ui/lib/locale'

ElementUI.Dialog.props.closeOnClickModal.default = false;

locale.use(
  Vue.prototype.i18n.locale === 'zh' 
    ? require('element-ui/lib/locale/lang/zh-CN').default 
    : require('element-ui/lib/locale/lang/en').default
)

Vue.use(ElementUI, {
  i18n: (key, value) => Vue.prototype.i18n.t(key, value),
});

import request from '@/api/request.js'; // 接口

Vue.use(request);
import local from '@/utils/local.js'
Vue.prototype.$local = local

import VueCookie from 'vue-cookie';
Vue.prototype.$cookie = VueCookie; // 检验操作的结果
// 全局loading
import '@/components/loading/index.js';


const { SM3 } = require('gm-crypto')

Vue.prototype.$md5 = md5;
Vue.prototype.$SM3 = SM3;

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')
